<template>
  <div>
    <b-row class="my-3">
      <b-col sm="3">
        <label>Show Scatter:</label>
      </b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-checkbox
            v-model="config.scatter"
            @change="onChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HistogramConfig',
  props: {
    initialConfig: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      config: {
        scatter: this.initialConfig.scatter || false,
      },
    };
  },
  mounted() {
    this.onChange();
  },
  methods: {
    onChange() {
      this.$emit('configChanged', this.config);
    },
  },
};
</script>

<style scoped></style>
